import { ActionIcon, Text } from '@mantine/core';
import { IconTableExport } from '@tabler/icons-react';
import Papa from 'papaparse';
import { logger } from 'utils/logger';

const CSVGenerator = ({ data, filename, ignoreKeys, includeKeys, flattenKeys, label = 'Export to CSV', icon = null }) => {
    const exportToCSV = () => {
        const csvData = convertArrayToCSV(data);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `${filename}.csv`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    };

    function convertToEscapedCommas(inputString) {
        // Use a regular expression to replace commas with an escape character (e.g., backslash)
        const escapedString = inputString.replace(/,/g, '\\,');

        return escapedString;
    }

    function convertToOriginal(inputString) {
        // Use a regular expression to replace escaped commas with regular commas
        const originalString = inputString.replace(/\\,/g, ',');

        return originalString;
    }

    const convertArrayToCSV = (data) => {
        var keys = data && data.length ? Object.keys(data[0]) : [];

        // Split the stringToRemove into an array of substrings
        var newArray = [];

        // need to flatten any objects or arrays in the data
        /**
         * an object can look like this:{
    "instructions": {
        "Web Stock OTB Date": "2025-05-19",
        "Web Photography Treatment": "CONTOUR",
        "Web Photography Notes": "",
        "Dept": "855",
        "Name": "B HWD29 BARBIE TIE DYE PLUSH ASSORTED",
        "ODBMS APN (GTIN)": "194735212729",
        "Web Photography Code": "69782152",
        "Web Photography Sample Size": "",
        "Parent keycode": "69782152",
        "Web Photography Style": "PRODUCT_SHOT",
        "department": "855 - DOLLS AND PLUSH",
        "guideCode": "",
        "guideName": "",
        "departmentStr": "855 - 855 - DOLLS AND PLUSH"
    },
    "seasonSort": "69782152",
    "captures": [],
    "seasonPart": "SEA-437084",
    "multiShotFlag": "",
    "studioSessionCodes": [],
    "outfittingFlag": "",
    "styleCount": "0",
    "id": "SEA-437084__69782152",
    "stylenumber": "69782152",
    "channels": []
}
         */
        if(flattenKeys && flattenKeys.length){
            const stringToFlatten = flattenKeys;
            const stringsToFlattenArray = stringToFlatten.split(',').map((str) => str.trim());
            // remove from the keys array
            keys = keys.filter((key) => !stringsToFlattenArray.includes(key));
            var childKeys = {}
            data = data.map((item) => {
                const newItem = { ...item };
                
                stringsToFlattenArray.forEach((keyToFlatten) => {
                    if (newItem[keyToFlatten] && typeof newItem[keyToFlatten] === 'object' && !Array.isArray(newItem[keyToFlatten])) {
                        // Get all properties from the nested object
                        const nestedObject = newItem[keyToFlatten];
                        Object.keys(nestedObject).forEach((nestedKey) => {
                            newItem[nestedKey] = nestedObject[nestedKey];
                            childKeys[nestedKey] = nestedKey;
                        });
                        // Remove the original nested key
                        delete newItem[keyToFlatten];
                    }
                });
                
                return newItem;
            });
        }
        if(childKeys && Object.keys(childKeys).length){
            keys = [...keys, ...Object.values(childKeys)];
        }

        if (ignoreKeys && ignoreKeys.length) {
            const stringToRemove = ignoreKeys; // Comma-separated list to remove
            const stringsToRemoveArray = stringToRemove.split(',').map((str) => str.trim());

            // Use the filter() method to create a new array excluding the strings to remove
            newArray = keys.filter((item) => !stringsToRemoveArray.includes(item));
        }

        if(includeKeys){
          newArray = includeKeys.split(',').map((str) => str.trim());
        }

        const tmpcsv = Papa.unparse(data, { columns: newArray });
        logger.log(tmpcsv);
        return tmpcsv;
        // return header + csv;
    };

    return (
        <div>
            {icon?<ActionIcon size='lg' variant='default' disabled={!data || data.length === 0} onClick={exportToCSV}>{icon}</ActionIcon>:
            <Text size='sm' disabled={!data || data.length === 0} onClick={exportToCSV}>
                {label}
            </Text>
            }
        </div>
    );
};

export default CSVGenerator;
